import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const MainMenu = ({ auth }) => {
  const [dropdownActive, setDropdownActive] = useState(false);

  const showDropdown = () => {
    setDropdownActive(true);
  };

  const hideDropdown = () => {
    setDropdownActive(false);
  };

  return (
    <div className="flex items-center relative">
      <img alt="logo" className="h-20 w-40 mr-4" src="assets/bitmap.svg" />
      <ul className="hidden md:flex">
        {auth.username && (
          <li className="ml-5">
            <Link to="/ticket" className="menu-link"><span>Ticket</span></Link>
          </li>
        )}
        {auth.isAdmin && (
          <>
            <li className="ml-5">
              <Link to="/allusers" className="menu-link"><span>Users</span></Link>
            </li>
            <li className="ml-5">
              <Link to="/roles" className="menu-link"><span>Roles</span></Link>
            </li>

    
            <li
              className="ml-5 dropdown relative"
              onMouseEnter={showDropdown}
              onMouseLeave={hideDropdown}
            >
              <span className="dropdown-trigger">Reports</span>
              {dropdownActive && (
                <ul className="dropdown-content absolute">
                  <li><Link to="/report" className="menu-link">Generic Reports</Link></li>
                  <li><Link to="/escbreakdownreport" className="menu-link">Escalation Breakdown Report</Link></li>
                  <li><Link to="/avgescreport" className="menu-link">Average Escalation Report</Link></li>
                  <li><Link to="/monthlyescreport" className="menu-link">Monthly Assigned Escalation's Report</Link></li>
                </ul>
              )}
            </li>
          </>
        )}
        {auth.username && (
          <li className="ml-5">
            <Link to="/history" className="menu-link"><span>History</span></Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default MainMenu;
